import React from 'react';

function SkeletonBlock({ width = '100%', height = 16, style = {} }) {
  return (
    <div className="skeleton-pulse" style={{ width, height, borderRadius: 8, ...style }} />
  );
}

export function SkeletonCard({ lines = 2, style = {} }) {
  return (
    <div style={{
      background: 'var(--card)',
      borderRadius: 14,
      padding: '14px 16px',
      border: '1px solid var(--bdr)',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      ...style,
    }}>
      <SkeletonBlock height={18} width="60%" />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} height={13} width={i === lines - 1 ? '80%' : '100%'} />
      ))}
    </div>
  );
}

export function SkeletonList({ count = 4, style = {} }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} lines={i % 3 === 0 ? 1 : 2} />
      ))}
    </div>
  );
}

export function SkeletonText({ lines = 3, style = {} }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} height={13} width={i === lines - 1 ? '70%' : '100%'} />
      ))}
    </div>
  );
}

export default SkeletonCard;
